import type { Dictionnaire } from '../type';
import { compte } from './pluriel';

const date = (jusqua: number) => new Date(jusqua).toLocaleDateString('ar-u-nu-latn');

export const sorties: Dictionnaire['sorties'] = {
  erreurs: {
    introuvable: 'الفعالية غير موجودة',
    titre: 'أعطِ فعاليتك عنوانًا',
    lieu: 'أدخل مكان اللقاء',
    adresse: 'اختر عنوانًا من القائمة المقترحة',
    horsZone: 'اختر عنوانًا داخل بلد هذا المكان.',
    lien: 'هذا الرابط لا يؤدي إلى أي مكان: تحقّق منه أو اترك الحقل فارغًا',
    dateInvalide: 'اختر تاريخًا صالحًا',
    datePassee: 'هذا التاريخ قد مضى',
    heureDebut: 'أدخل وقت البداية',
    heureFin: 'أدخل وقت النهاية',
    finDifferente: 'يجب أن يختلف وقت النهاية عن وقت البداية',
    passe: {
      inscrire: 'لم يعد بإمكانك الانضمام إليها',
      valider: 'لم يعد بالإمكان قبول الطلبات',
      modifier: 'لم يعد بالإمكان تعديلها',
      figee: 'قائمة المشاركين مقفلة',
      retirer: 'لم يعد بإمكانك الانسحاب منها',
      reprendre: 'لم يبقَ شيء لتتولاه',
      supprimer: 'لم يعد بالإمكان حذفها',
    },
    annuleFaute: 'أُلغيت هذه الفعالية لقلة المشاركين',
    complet: 'كل الأماكن محجوزة، حرّر مكانًا قبل القبول',
    pasInscrite: 'هذا الشخص غير مسجّل في هذه الفعالية',
    feuillePasFinie: 'يُسجَّل الحضور بعد انتهاء الفعالية',
    feuilleValidee: 'ورقة الحضور هذه مؤكّدة بالفعل',
    note: 'التقييم من 1 إلى 5',
    finApresDebut: 'يجب أن يكون وقت النهاية بعد وقت البداية',
    tropTard: 'تبدأ هذه الفعالية بعد أقل من عشر ساعات: لم يعد بالإمكان تعديلها',
    creneauPasse: 'هذا الموعد قد مضى',
    organisateurReste: 'أنت منظّم هذه الفعالية، لا يمكنك إزالة نفسك',
    sansGroupe: 'ليس لهذه الفعالية مجموعة',
    seulOrganisateur: 'المنظّم وحده يدير المشاركين',
    organisateurPart: 'أنت منظّم هذه الفعالية: سلّمها لغيرك أو احذفها',
    autreQuelquun: 'اختر شخصًا آخر ليتولى الفعالية',
    neParticipePas: 'هذا الشخص لا يشارك في الفعالية',
    nombreParticipants: (min: number, max: number) => `يجب أن يكون عدد المشاركين بين ${min} و${max}`,
    suspendu: (jusqua: number) =>
      `تغيّبت عن فعاليتين دون إبلاغ أحد: يمكنك التسجيل من جديد في ${date(jusqua)}`,
    estPasse: (raison: string) => `انتهت هذه الفعالية: ${raison}`,
    creneauPris: (titre: string) => `أنت مشغول في هذا الوقت، مع «${titre}»`,
  },
  carte: {
    inscrit: 'مسجّل',
    enAttente: 'قيد الانتظار',
    complet: 'مكتملة',
    note: (note: string) => `تقييم المنظّم ${note} من 5`,
    participants: (n: number, max: number) => `${n}/${max} مشاركين`,
  },
  commun: {
    autresActions: 'إجراءات أخرى',
    lieu: 'المكان',
    date: 'التاريخ',
    participants: 'المشاركون',
    monBillet: 'تذكرتي',
    enLigne: 'عبر الإنترنت',
    masquerQ: 'إخفاء هذه الفعالية؟',
    masquer: 'إخفاء هذه الفعالية',
    actionImpossible: 'تعذّر ذلك الآن.',
  },
  fiche: {
    noteNonEnvoyee: 'تعذّر إرسال هذا التقييم.',
    groupeImpossible: 'تعذّر فتح المجموعة',
    ecrireImpossible: 'لا يمكنك مراسلته الآن.',
    desinscrireQ: 'الانسحاب من هذه الفعالية؟',
    titre: 'فعالية',
    adresseComplete: 'العنوان الكامل',
    partager: 'مشاركة الفعالية',
    retirerMasques: 'إزالة من المخفية',
    presenceEnregistree: 'سُجّل حضورك.',
    montreLeCarre: 'أظهر هذا الرمز للمنظّم عند وصولك: إنه يؤكد حضورك.',
    passe: 'انتهت هذه الفعالية',
    gerer: 'إدارة فعاليتي',
    rejoindreGroupe: 'الانضمام إلى المجموعة',
    groupe: 'مجموعة الفعالية',
    monAgenda: 'مفكرتي',
    presenceConfirmee: 'تم تأكيد الحضور',
    horaire: 'الوقت',
    places: 'الأماكن',
    lien: 'الرابط',
    lienApresInscription: 'بعد التسجيل',
    rejoindre: (hote: string) => `الانضمام عبر ${hote}`,
    noteOrganisateur: 'قيّم المنظّم',
    commentCaSEstPasse: 'كيف كانت هذه الفعالية؟',
    noteSurCinq: 'التقييم من 5',
    langues: 'اللغات',
    description: 'الوصف',
    organise: 'المنظّم',
    prevenir: 'أبلغ المنظّم إذا لم تعد تستطيع الحضور. غيابان دون إبلاغ يغلقان التسجيل في الفعاليات لمدة أسبوع.',
    autresApresAcceptation: 'يظهر المشاركون الآخرون بعد قبول مشاركتك.',
    annulerDemande: 'إلغاء طلبي',
    meDesinscrire: 'الانسحاب من الفعالية',
    listeAttente: 'الانضمام إلى قائمة الانتظار',
    demanderAParticiper: 'طلب المشاركة',
    participer: 'المشاركة',
    gererDemandes: (n: number) => `إدارة · ${compte(n, 'طلب واحد', 'طلبان', 'طلبات', 'طلبًا')}`,
    suspendu: (jusqua: number) => `غيابان دون إبلاغ: يمكنك التسجيل من جديد في ${date(jusqua)}`,
    organisePar: (nom: string) => `ينظّمها ${nom}`,
    ecrireA: (nom: string) => `مراسلة ${nom}`,
    noteAide: (nom: string) => `قيّم ${nom}. لا يمكن سحب التقييم.`,
    surCinq: (n: number) => `${n} من 5`,
    donnerQ: (n: number, nom: string) => `منح ${nom} ${compte(n, 'نجمة واحدة', 'نجمتين', 'نجوم', 'نجمة')}؟ هذا التقييم نهائي.`,
    demandesEnAttente: (n: number) => `${compte(n, 'طلب واحد', 'طلبان', 'طلبات', 'طلبًا')} بانتظار ردّك.`,
  },
  gestion: {
    groupeImpossible: 'تعذّر إنشاء المجموعة.',
    passationImpossible: 'تعذّر التسليم الآن.',
    feuilleTousLa: 'تم تأكيد الحضور. كان الجميع حاضرين.',
    validationImpossible: 'تعذّر التأكيد الآن.',
    scan: {
      pasSirocco: 'هذا الرمز ليس من Sirocco.',
      autreSortie: 'هذه التذكرة لفعالية أخرى.',
      pasInscrite: 'هذا الشخص غير مسجّل هنا.',
      impossible: 'تعذّر التسجيل.',
      dejaPresent: (nom: string) => `${nom} مسجّل حاضرًا بالفعل.`,
      present: (nom: string) => `${nom} · حاضر`,
    },
    suppressionImpossible: 'تعذّر الحذف الآن.',
    quitter: 'مغادرة الفعالية',
    supprimerQ: 'حذف الفعالية؟',
    supprimer: 'حذف الفعالية',
    aQui: 'لمن تسلّم تنظيم الفعالية؟',
    modifier: 'تعديل الفعالية',
    scanner: 'مسح التذاكر',
    reserve: 'للمنظّم فقط',
    reserveAide: 'وحده منظّم هذه الفعالية يستطيع إدارة مشاركيها.',
    tropTard: 'فات أوان التعديل: تبدأ الفعالية بعد أقل من عشر ساعات.',
    scannerUn: 'مسح تذكرة',
    ouvrirGroupe: 'فتح المجموعة',
    creerGroupe: 'إنشاء المجموعة',
    personneAReunir: 'لا أحد لجمعه',
    demandes: 'الطلبات',
    feuilleAVerifier: 'ورقة حضور للمراجعة',
    feuilleAide: 'افتح قائمة المشاركين، وأشّر على من حضر، ثم أكّد. سيُحتسب الآخرون غائبين؛ وغيابان يغلقان تسجيل العضو لمدة أسبوع.',
    validerTousQ: 'تأكيد الحضور؟ الجميع مسجّلون حاضرين.',
    valider: 'تأكيد الحضور',
    modificationImpossible: 'تعذّر حفظ التعديلات.',
    champs: {
      titre: 'العنوان',
      debut: 'البداية',
      fin: 'النهاية',
    },
    placesGardees: 'يحتفظ المشاركون المسجّلون بأماكنهم. لا يمكن تغيير عدد الأماكن.',
    enregistrer: 'حفظ',
    ouvertureCamera: 'جارٍ فتح الكاميرا…',
    feuilleAbsents: (n: number) => `تم تأكيد الحضور. سُجّل ${compte(n, 'غياب واحد', 'غيابان', 'غيابات', 'غيابًا')}.`,
    laisserQ: (nom: string) => `تسليم تنظيم الفعالية إلى ${nom}؟`,
    valideeLe: (date: string) => `تم تأكيد الحضور في ${date}`,
    validerQ: (n: number) => `تأكيد الحضور؟ ${compte(n, 'شخص واحد سيُحتسب', 'شخصان سيُحتسبان', 'أشخاص سيُحتسبون', 'شخصًا سيُحتسبون')} غائبين.`,
  },
  categories: {
    sport: 'رياضة',
    culture: 'ثقافة',
    pro: 'مهني',
    food: 'طعام',
    asso: 'جمعية',
    etudes: 'دراسة',
    jeux: 'ألعاب',
  },
  reserve: {
    titre: 'للمنظّم فقط',
  },
  creation: {
    impossible: 'تعذّر النشر',
    titreSortie: 'اقترح خرجة',
    titreEvenement: 'إنشاء فعالية',
    publierSortie: 'نشر الخرجة',
    publierEvenement: 'نشر الفعالية',
    type: 'نوع الخرجة',
    evenement: 'فعالية',
    spontanee: 'عفوية',
    enLigne: 'عبر الإنترنت',
    affiche: 'ملصق (اختياري)',
    choisirAffiche: 'اختيار ملصق',
    retirerAffiche: 'إزالة الملصق',
    quoi: 'ماذا؟',
    titre: 'العنوان',
    exempleSortie: 'قهوة عند الساعة',
    exempleEvenement: 'كرة قدم خماسية',
    categorie: 'الفئة',
    horaires: 'الوقت',
    heureDebut: 'وقت البداية',
    heureFin: 'وقت النهاية',
    ouSurLeCampus: 'أين في الحرم؟ مدرّج، قاعة، ملعب…',
    campusAile: (aile: string) => (aile.length <= 2 ? `الجناح ${aile}` : aile),
    campusEtage: (n: number) => (n === 0 ? 'الطابق الأرضي' : n === 1 ? 'الطابق الأول' : n === 2 ? 'الطابق الثاني' : `الطابق ${n}`),
    chercheAdresse: 'ابحث عن عنوان',
    lien: 'رابط الانضمام (اختياري)',
    lienExemple: 'https://zoom.us/j/…',
    lienAide: 'مكالمة فيديو، خادم Discord… لن يراه في صفحة الفعالية إلا المسجّلون.',
    placeSurLePlan: 'محدّدة على الخريطة، اضغط لنقلها',
    placerSurLePlanBouton: 'التحديد على خريطة الحرم',
    annuaireMuet: 'دليل العناوين لا يستجيب. أعد المحاولة بعد قليل.',
    aucuneAdresse: 'لم يُعثر على عنوان. أضف الشارع أو اسم المكان.',
    nombreParticipants: 'عدد المشاركين',
    maximum: 'الحد الأقصى',
    retirerPlace: 'إزالة مكان',
    ajouterPlace: 'إضافة مكان',
    seConfirme: 'تتأكّد ابتداءً من',
    abaisserSeuil: 'خفض الحد الأدنى',
    aucun: 'لا شيء',
    releverSeuil: 'رفع الحد الأدنى',
    description: 'الوصف',
    descriptionExemple: 'ما يجب معرفته: المستوى، المعدّات، نقطة اللقاء…',
    validation: 'قبول المشاركين يدويًا',
    langues: 'اللغة المستعملة',
    languesTitre: 'اللغات المستعملة',
    languesMax: 'ثلاث لغات كحد أقصى.',
    languesChercher: 'ابحث عن لغة',
    languesAucune: 'لا توجد لغة مطابقة.',
    languesTermine: 'تم',
    languesNoms: { ary: 'الدارجة المغربية', zgh: 'الأمازيغية' },
  },
  filtres: {
    titre: 'تصفية الفعاليات',
    quand: 'متى',
    du: 'من',
    aPartirDu: 'ابتداءً من',
    au: 'إلى',
    jusquAu: 'حتى',
    distance: 'المسافة',
    rayon: 'النطاق من حولي',
    sansDistance: 'لا مسافة محدّدة',
    sansPosition: 'تعذّر تحديد موقعك. تصفية المسافة تحتاج إلى موقعك.',
    nature: 'النوع',
    spontanees: 'خرجات عفوية',
    enLigne: 'عبر الإنترنت',
    categories: 'الفئات',
    langues: 'اللغات',
    toutesLangues: 'كل اللغات',
    appliquer: 'تطبيق التصفية',
    effacer: 'مسح',
    kilometres: (n: number) => `${n} كم`,
  },
  liste: {
    rechercher: 'بحث…',
    carte: 'خريطة الفعاليات',
    agenda: 'مفكرتي',
    creer: 'إنشاء فعالية',
    masques: 'الفعاليات المخفية',
    filtreActif: 'تصفية · هناك تصفية مفعّلة',
    filtrer: 'تصفية',
    unSansAdresse: 'خرجة واحدة بلا عنوان دقيق لا تُحتسب في هذا النطاق.',
    aucun: 'لا توجد فعاليات',
    elargir: 'جرّب توسيع الفئات.',
    personne: 'لم يقترح أحد خرجة هنا بعد.',
    proposer: 'اقترح خرجة',
    pourToi: 'لك',
    toutes: 'كل الخرجات',
    sansAdresse: (n: number) => `${compte(n, 'خرجة واحدة', 'خرجتان', 'خرجات', 'خرجة')} بلا عنوان دقيق لا تُحتسب في هذا النطاق.`,
    rienAMoinsDe: (km: number) => `لا شيء على بعد أقل من ${km} كم منك. جرّب نطاقًا أوسع.`,
  },
  agenda: {
    onglets: {
      aVenir: 'القادمة',
      jOrganise: 'أنظّمها',
    },
    titre: 'مفكرتي',
    semaine: 'هذا الأسبوع',
    plusTard: 'لاحقًا',
    rien: 'لا شيء لعرضه هنا',
    rienAide: 'سجّل في خرجة أو اقترح خرجتك: ستظهر هنا.',
    rienOrganise: 'ستظهر هنا الفعاليات التي تنظّمها.',
    voir: 'عرض الفعاليات',
    proposer: 'اقترح خرجة',
  },
  participants: {
    titre: 'المشاركون',
    reserveAide: 'وحده منظّم هذه الفعالية يستطيع رؤية هذه القائمة.',
    chercher: 'ابحث عن مشارك',
    personne: 'لا أحد بهذا الاسم في هذه الفعالية.',
    present: 'حاضر',
    organise: 'المنظّم',
    absent: 'غائب',
    retirerQ: (nom: string) => `إزالة ${nom} من الفعالية؟`,
    retirerPresence: (nom: string) => `إلغاء حضور ${nom}`,
    estLa: (nom: string) => `${nom} حاضر`,
  },
  demandes: {
    titre: 'الطلبات',
    reserveAide: 'وحده منظّم هذه الفعالية يستطيع معالجة طلباتها.',
    chercher: 'ابحث في الطلبات',
    personne: 'لا أحد بهذا الاسم في الطلبات.',
    aucune: 'لا توجد طلبات',
    aucuneAide: 'ستصل طلبات المشاركة إلى هنا.',
    ouvert: 'تقبل هذه الفعالية الجميع تلقائيًا ما دامت هناك أماكن متبقية.',
    rang: (rang: number) => `الرقم ${rang} في القائمة`,
    accepter: (nom: string) => `قبول ${nom}`,
    refuser: (nom: string) => `رفض ${nom}`,
  },
  miennes: {
    onglets: {
      inscrit: 'مسجّل',
      organise: 'أنظّمها',
      passes: 'السابقة',
    },
    vides: {
      inscrit: 'ستظهر تسجيلاتك هنا.',
      organise: 'ستظهر هنا الفعاليات التي تنظّمها.',
      passes: 'ستظهر هنا الفعاليات التي تأكّد حضورك فيها.',
    },
    titre: 'فعالياتي وخرجاتي',
    uneFeuille: 'ورقة حضور واحدة للمراجعة',
    rien: 'لا شيء لعرضه هنا',
    feuilles: (n: number) => `${compte(n, 'ورقة حضور واحدة', 'ورقتا حضور', 'أوراق حضور', 'ورقة حضور')} للمراجعة`,
  },
  masques: {
    titre: 'الفعاليات المخفية',
    aucun: 'لا توجد فعاليات مخفية',
    aucunAide: 'تنتهي هنا الفعاليات التي تخفيها من صفحتها.',
    remettre: 'افتح فعالية لتعيدها إلى قوائمك.',
  },
};
